"use client";

import { useQuery } from "@tanstack/react-query";

import { getFocusUser } from "@/backend/focus";
import {
  FOCUS_PROFILE_CACHE_MAX_AGE_MS,
  FOCUS_PROFILE_QUERY_KEY,
} from "@/utils/query-persistence";

export const getFocusProfileQueryKey = (publicKey?: string | null) =>
  [FOCUS_PROFILE_QUERY_KEY, publicKey ?? ""] as const;

export const useFocusProfileQuery = ({
  enabled = true,
  publicKey,
}: {
  enabled?: boolean;
  publicKey?: string | null;
}) => {
  return useQuery({
    queryKey: getFocusProfileQueryKey(publicKey),
    queryFn: async () => {
      if (!publicKey) {
        return null;
      }

      const response = await getFocusUser(publicKey).catch(() => null);
      return response?.data ?? null;
    },
    enabled: enabled && !!publicKey,
    gcTime: FOCUS_PROFILE_CACHE_MAX_AGE_MS,
    placeholderData: (previousData) => previousData ?? null,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};
